/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Digest_NoInputs */

const en_platform_digest_no = /** @type {(inputs: Platform_Digest_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't make it`)
};

const pl_platform_digest_no = /** @type {(inputs: Platform_Digest_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie dam rady`)
};

/**
* | output |
* | --- |
* | "Can't make it" |
*
* @param {Platform_Digest_NoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_digest_no = /** @type {((inputs?: Platform_Digest_NoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Digest_NoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_digest_no(inputs)
	return en_platform_digest_no(inputs)
});